/* eslint-disable */
/**
 * 该文件是为了按需加载，剔除掉了一些不需要的框架组件。
 * 减少了编译支持库包大小
 *
 * 当需要更多组件依赖时，在该文件加入即可
 */
import Vue from 'vue'
// import 'vant/lib/index.css';
import 'vant/lib/icon/local.css';
import {
    ActionSheet,
    Cell,
    CellGroup,
    Checkbox,
    CheckboxGroup,
    Empty,
    Field,
    Form,
    Button,
    DatetimePicker,
    Dialog,
    Icon,
    Tab,
    Tabs,
    Tabbar,
    TabbarItem,
    RadioGroup,
    Radio,
    NavBar,
    NoticeBar,
    Toast,
    Popup,
    Picker,
    Stepper,
    Switch,
    Overlay,
    Loading,
    Image as VanImage
}
from 'vant'

Vue.use(ActionSheet)
Vue.use(Button)
Vue.use(Icon)
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Empty);
Vue.use(Dialog);
Vue.use(DatetimePicker);
Vue.use(Tab).use(Tabs)
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(RadioGroup).use(Radio)
Vue.use(Field)
Vue.use(NavBar);
Vue.use(NoticeBar);
Vue.use(Popup);
Vue.use(Toast);
Vue.use(Picker);
Vue.use(Stepper);
Vue.use(Switch);
Vue.use(VanImage);
Vue.use(Form);
Vue.use(Overlay);
Vue.use(Loading);

Vue.prototype.$Toast = Toast;
Vue.prototype.$Dialog = Dialog;